export const constants = {


    LOAD_REQUEST: 'COMUNI_LOAD_REQUEST',
    LOAD_SUCCESS: 'COMUNI_LOAD_SUCCESS',
    LOAD_FAILURE: 'COMUNI_LOAD_FAILURE',
    
};
